"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _AccordionComponent = _interopRequireDefault(require("./AccordionComponent"));
var __jsx = _react.default.createElement;
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AccordionEditConfig = {
  emptyLabel: 'Accordion',
  isEmpty: function isEmpty(props) {
    if (props.children && props.children.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var Accordion = /*#__PURE__*/function (_Container) {
  (0, _inherits2.default)(Accordion, _Container);
  var _super = _createSuper(Accordion);
  function Accordion() {
    (0, _classCallCheck2.default)(this, Accordion);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(Accordion, [{
    key: "containerProps",
    get: function get() {
      var containerProps = (0, _get2.default)((0, _getPrototypeOf2.default)(Accordion.prototype), "containerProps", this);
      containerProps.className = (containerProps.className || '') + ' cmp-accordion aem-ms-cmp aem-ms-accordion';
      containerProps.role = 'group';
      containerProps['data-cmp-is'] = 'accordion';
      return containerProps;
    }
  }, {
    key: "render",
    value: function render() {
      var faqSchema = this.props.faqContent;
      return __jsx("div", (0, _extends2.default)({}, this.containerProps, {
        "aria-label": this.props.accessibilityLabel,
        id: this.props.anchorId,
        itemScope: faqSchema,
        itemType: faqSchema ? 'https://schema.org/FAQPage' : false
      }), __jsx(_AccordionComponent.default, {
        faqContent: faqSchema,
        children: this.childComponents,
        expandedItems: this.props.expandedItems,
        singleExpansion: this.props.singleExpansion,
        headingElement: this.props.headingElement
      }), this.placeholderComponent);
    }
  }]);
  return Accordion;
}(_aemReactEditableComponents.Container);
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/accordion')(Accordion, AccordionEditConfig);
exports.default = _default;